import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { styled, useTheme } from '@mui/material/styles'
import { safeJsonParse } from '../utils/jsonUtils'
import Box from '@mui/material/Box'
import Drawer from '@mui/material/Drawer'
import CssBaseline from '@mui/material/CssBaseline'
import MuiAppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import List from '@mui/material/List'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'
import IconButton from '@mui/material/IconButton'
import WalletIcon from '@mui/icons-material/Wallet'
import GroupsIcon from '@mui/icons-material/Groups'
import { Button, Collapse, Menu, MenuItem } from '@mui/material'
import ListIcon from '@mui/icons-material/List'
import UploadIcon from '@mui/icons-material/Upload'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import LogoIcon from '../assets/img/blue-logo.png'
import DashboardIcon from '@mui/icons-material/Dashboard'
import PersonIcon from '@mui/icons-material/Person'
import AssignmentReturnedIcon from '@mui/icons-material/AssignmentReturned'
import DescriptionIcon from '@mui/icons-material/Description'
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import BuildCircleOutlinedIcon from '@mui/icons-material/BuildCircleOutlined'
import { useNavigate, Outlet, useLocation } from 'react-router-dom'
import CloudUpload from '@mui/icons-material/CloudUpload'
import CreditCardIcon from '@mui/icons-material/CreditCard'
import KRIcon from '../assets/img/gray-kr.svg'
import axios from '../api/axios'
import MenuIcon from '@mui/icons-material/Menu'
import { clearAccountData } from '../features/account/account'
import socket from '../socket'
import toast from 'react-hot-toast'

const drawerWidth = 240

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
   ({ theme, open }) => ({
      flexGrow: 1,
      padding: '0px',
      transition: theme.transitions.create('margin', {
         easing: theme.transitions.easing.sharp,
         duration: theme.transitions.duration.leavingScreen,
      }),
      marginLeft: `-${drawerWidth}px`,
      ...(open && {
         transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
         }),
         marginLeft: 0,
      }),
   })
)

const AppBar = styled(MuiAppBar, {
   shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
   transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
   }),
   ...(open && {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: `${drawerWidth}px`,
      transition: theme.transitions.create(['margin', 'width'], {
         easing: theme.transitions.easing.easeOut,
         duration: theme.transitions.duration.enteringScreen,
      }),
   }),
}))

const DrawerHeader = styled('div')(({ theme }) => ({
   display: 'flex',
   alignItems: 'center',
   padding: theme.spacing(0, 1),
   ...theme.mixins.toolbar,
   justifyContent: 'flex-end',
}))


export default function UserSidebar() {
   // const account = useSelector((state) => state.account)
   const [account, setAccount] = useState(null)
   const theme = useTheme()
   const dispatch = useDispatch()
   const [open, setOpen] = useState(true)
   const [logo, setLogo] = useState('')
   const [myID, setMyID] = useState('')
   const [anchorElUser, setAnchorElUser] = useState(null)
   const navigate = useNavigate()
   const location = useLocation()
   const currentPath = location.pathname

   const pageTitles = {
      '/dashboard': 'Dashboard',
      '/upload': 'Upload',
      '/overview': 'File Overview',
      '/pricelist': 'Price List',
      '/toolbox': 'Toolbox',
      '/overviewCredit': 'Credit Overview',
      '/buyCredit': 'Buy File Credits',
      '/profile': 'Profile',
      '/support': 'Support',
   }

   const pageTitle = pageTitles[currentPath] || 'OEMSERVICE'
   const isActive = (path) => currentPath === path
   const isFileServiceActive =
      currentPath === '/upload' || currentPath === '/overview'
   const isCreditActive =
      currentPath === '/overviewCredit' || currentPath === '/buyCredit'
   const [listopen, setListOpen] = useState(true)
   const [creditopen, setCreditOpen] = useState(true)
   const [unreadCount, setUnreadCount] = useState(0)
   const [unreadFileCount, setUnreadFileCount] = useState(0)
   const [creditAmount, setCreditAmount] = useState(0)
   const [mobileView, setMobileView] = useState(false)
   const audioContextRef = useRef(null)

   const playReadySound = () => {
      try {
         const audio = new Audio('/sounds/file-ready.wav')
         audio.volume = 0.65
         audio.play().catch((error) => {
            if (process.env.REACT_APP_MODE)
               console.log('Ready sound blocked:', error)
         })
      } catch (error) {
         if (process.env.REACT_APP_MODE)
            console.log('Ready sound error:', error)
      }
   }
   const handleOpenUserMenu = (event) => {
      setAnchorElUser(event.currentTarget)
   }

   const handleCloseUserMenu = () => {
      setAnchorElUser(null)
   }

   const handleDrawerClose = () => {
      setOpen(false)
   }
   const getUserUnreadCount = async (id) => {
      try {
         await axios
            .post(`getUserUnreadCount`, {
               id: id,
            })
            .then((result) => {
               if (result.data.status) {
                  setUnreadCount(Number(result.data.supportUnreadCount) || 0)
               }
            })
      } catch (error) {
         if (process.env.REACT_APP_MODE) console.log(error)
      }
   }

   const getUserUnreadPerFileCount = async (id) => {
      try {
         await axios
            .post(`getUserUnreadPerFileCount`, {
               id: id,
            })
            .then((result) => {
               if (result.data.status) {
                  setUnreadFileCount(Number(result.data.unreadCount) || 0)
               }
            })
      } catch (error) {
         if (process.env.REACT_APP_MODE) console.log(error)
      }
   }

   const getLogo = async () => {
      try {
         await axios
            .post(`getLogo`)
            .then((result) => {
               if (result.data.status) {
                  setLogo(process.env.REACT_APP_BASE_URL + result.data.data)
               }
            })
      } catch (error) {
         if (process.env.REACT_APP_MODE) console.log(error)
      }
   }

   const checkMsg = async () => {
      try {
         await axios
            .post(`updateUserReadStatus`, {
               id: myID,
            })
            .then((result) => {
               if (result.data.status) {
                  navigate('/support')
                  setUnreadCount(0)
               }
            })
      } catch (error) {
         if (process.env.REACT_APP_MODE) console.log(error)
      }
   }

   const getSumCredit = async (id) => {
      try {
         await axios
            .post(`getSumCredit`, { id })
            .then((result) => {
               if (result.data.status) {
                  setCreditAmount(result.data.data)
               } else {
                  toast.error(result.data.data)
               }
            })
      } catch (error) {
         if (process.env.REACT_APP_MODE) console.log(error)
      }
   }

   const getWidth = () =>
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth

   useEffect(() => {
      const user = localStorage.getItem('user')
      if (user) {
         let parse = safeJsonParse(user);
         setAccount(parse)
      }
   }, [])

   useEffect(() => {
      const setResponsiveness = () => {
         getWidth() < 600 ? setMobileView(true) : setMobileView(false)
      }
      window.addEventListener('resize', setResponsiveness)
      return () => {
         window.removeEventListener('resize', setResponsiveness)
      }
   }, [])

   useEffect(() => {
      const check = window.location.href.search('support')
      if (check > 0) {
         checkMsg()
      }
   }, [window.location, unreadCount])

   useEffect(() => {
      getLogo()
      if (account) {
         setMyID(account?._id)
         getSumCredit(account?._id)
         const handleAccountMessage = async () => {
            setUnreadCount((prev) => (Number(prev) || 0) + 1)
         }

         const handleFileReply = async () => {
            setUnreadFileCount((prev) => (Number(prev) || 0) + 1)
            setListOpen(true)
            playReadySound()
            toast.success('Your tuned file is ready', {
               duration: 6000,
            })
         }

         const handleTotalUnreadCount = async (e) => {
            setUnreadFileCount((prev) =>
               Math.max(
                  0,
                  (Number(prev) || 0) - (Number(e?.count) || 0)
               )
            )
         }

         const handleCreditCheck = async () => {
            getSumCredit(account?._id)
         }

         socket.on(account?._id, handleAccountMessage)
         socket.on('fileReply' + account?._id, handleFileReply)
         socket.on(
            'totalUnreadCount' + account?._id,
            handleTotalUnreadCount
         )
         socket.on(
            'creditCheck' + account?._id,
            handleCreditCheck
         )

         return () => {
            socket.off(account?._id, handleAccountMessage)
            socket.off(
               'fileReply' + account?._id,
               handleFileReply
            )
            socket.off(
               'totalUnreadCount' + account?._id,
               handleTotalUnreadCount
            )
            socket.off(
               'creditCheck' + account?._id,
               handleCreditCheck
            )
         }
      }
   }, [account, unreadCount, unreadFileCount])

   useEffect(() => {
      if (account) {
         getUserUnreadCount(account?._id)
         getUserUnreadPerFileCount(account?._id)
      }
   }, [account])
   return (
      <Box sx={{ display: 'flex' }}>
         <CssBaseline />
         <AppBar position="fixed" open={open}>
            <Toolbar
               style={{
                  backgroundColor: '#163A5F',
                  justifyContent: 'space-between',
               }}
            >
               <Box display={'flex'}>
                  {open ? (
                     <></>
                  ) : (
                     <Box
                        sx={{
                           display: 'flex',
                           alignItems: 'center',
                           gap: '7px',
                           mr: 2,
                           whiteSpace: 'nowrap',
                        }}
                     >
                        <Typography
                           sx={{
                              color: '#FFFFFF',
                              fontSize: '18px',
                              fontWeight: 700,
                              letterSpacing: '0.3px',
                           }}
                        >
                           FILE HUB
                        </Typography>

                        <Box
                           sx={{
                              px: '7px',
                              py: '3px',
                              bgcolor: '#00A9CE',
                              color: '#FFFFFF',
                              borderRadius: '999px',
                              fontSize: '10px',
                              fontWeight: 800,
                              lineHeight: 1,
                           }}
                        >
                           V2
                        </Box>
                     </Box>
                  )}
                  <IconButton
                     aria-label="open drawer"
                     onClick={() => setOpen(true)}
                     edge="start"
                     sx={{ mx: 1, color: 'white', ...(open && { display: 'none' }) }}
                  >
                     <MenuIcon />
                  </IconButton>
                  {open && (
                     <Typography
                        sx={{
                           color: '#FFFFFF',
                           fontSize: '24px',
                           fontWeight: 500,
                           ml: 1,
                        }}
                     >
                        {pageTitle}
                     </Typography>
                  )}
               </Box>
               <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Box
                     sx={{
                        color: 'white',
                        display: 'flex',
                        pr: '10px',
                        fontSize: '14px',
                        alignItems: 'center',
                     }}
                  >
                     <CreditCardIcon sx={{ color: 'white' }} />
                     {creditAmount} {creditAmount === 1 ? 'Credit' : 'Credits'}
                  </Box>
                  <Divider orientation="vertical" flexItem />
                  <Box
                     sx={{
                        display: 'flex',
                        alignItems: 'center',
                        padding: '10px',
                        color: 'white',
                        cursor: 'pointer',
                     }}
                     onClick={() => navigate('support')}
                  >
                     {mobileView ? '' : 'Chat'}
                     <GroupsIcon />{' '}
                  </Box>
               </Box>
            </Toolbar>
            <Toolbar sx={{ bgcolor: '#F8FAFC', p: '10px' }}>
               <div style={{ flex: '1' }}></div>
               <Button
                  onClick={() => {
                     navigate('pricelist')
                  }}
                  sx={{
                     bgcolor: 'white',
                     color: '#163A5F',
                     border: '1px solid #D0D5DD',
                     mr: '12px',
                     borderRadius: '8px',
                     textTransform: 'none',
                     fontWeight: 600,
                     boxShadow: '0 1px 2px rgba(16,24,40,0.05)',
                  }}
                  variant="outlined"
               >
                  <ListIcon /> {mobileView ? '' : 'Price List'}
               </Button>
               <Button
                  sx={{
                     bgcolor: 'white',
                     color: '#163A5F',
                     border: '1px solid #D0D5DD',
                     mr: '12px',
                     borderRadius: '8px',
                     textTransform: 'none',
                     fontWeight: 600,
                     boxShadow: '0 1px 2px rgba(16,24,40,0.05)',
                  }}
                  onClick={() => {
                     navigate('upload')
                  }}
                  variant="outlined"
               >
                  <UploadIcon /> {mobileView ? '' : 'Upload File'}
               </Button>
               <Button
                  sx={{ bgcolor: 'white', color: '#163A5F' }}
                  onClick={handleOpenUserMenu}
               >
                  <PersonIcon /> {mobileView ? '' : 'Dashboard'}
               </Button>
               <Menu
                  sx={{ mt: '45px' }}
                  id="menu-appbar"
                  anchorEl={anchorElUser}
                  anchorOrigin={{
                     vertical: 'top',
                     horizontal: 'right',
                  }}
                  keepMounted
                  transformOrigin={{
                     vertical: 'top',
                     horizontal: 'right',
                  }}
                  open={Boolean(anchorElUser)}
                  onClose={handleCloseUserMenu}
               >
                  <MenuItem
                     onClick={() => {
                        handleCloseUserMenu()
                        navigate('profile')
                     }}
                  >
                     <Typography textAlign="center">Profile</Typography>
                  </MenuItem>
                  <MenuItem
                     onClick={() => {
                        localStorage.clear();
                         window.location.replace(`${window.origin}/`)
                     }}
                  >
                     <Typography textAlign="center">Log out</Typography>
                  </MenuItem>
               </Menu>
            </Toolbar>
         </AppBar>
         <Drawer
            sx={{
               width: drawerWidth,
               flexShrink: 0,
               '& .MuiListItemButton-root.Mui-selected': {
                  backgroundColor: '#EAF2FB',
                  color: '#163A5F',
                  fontWeight: 600,
               },
               '& .MuiListItemButton-root.Mui-selected:hover': {
                  backgroundColor: '#EAF2FB',
               },
               '& .MuiListItemButton-root.Mui-selected .MuiListItemIcon-root': {
                  color: '#163A5F',
               },
               '& .MuiDrawer-paper': {
                  width: drawerWidth,
                  boxSizing: 'border-box',
                  bgcolor: '#FFFFFF',
                  borderRight: '1px solid #E4E7EC',
               },
               '& .MuiListItemButton-root': {
                  mx: 1,
                  my: 0.25,
                  borderRadius: '8px',
                  color: '#344054',
               },
               '& .MuiListItemButton-root:hover': {
                  bgcolor: '#F2F4F7',
               },
               '& .MuiListItemIcon-root': {
                  minWidth: '44px',
                  color: '#7A8797',
               },
            }}
            variant="persistent"
            anchor="left"
            open={open}
         >
            <DrawerHeader>
               <Box
                  sx={{
                     display: 'flex',
                     alignItems: 'center',
                     gap: '7px',
                  }}
               >
                  <Box
                     sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        lineHeight: 1,
                     }}
                  >
                     <Box
                        sx={{
                           display: 'flex',
                           alignItems: 'baseline',
                           gap: '5px',
                           whiteSpace: 'nowrap',
                        }}
                     >
                        <Box
                           component="span"
                           sx={{
                              fontSize: '20px',
                              fontWeight: 800,
                              letterSpacing: '-0.4px',
                              color: '#163A5F',
                           }}
                        >
                           FILE
                        </Box>

                        <Box
                           component="span"
                           sx={{
                              fontSize: '20px',
                              fontWeight: 500,
                              letterSpacing: '0.3px',
                              color: '#163A5F',
                           }}
                        >
                           HUB
                        </Box>
                     </Box>

                     <Box
                        sx={{
                           mt: '4px',
                           fontSize: '9px',
                           fontWeight: 600,
                           letterSpacing: '0.8px',
                           color: '#7A8699',
                           textTransform: 'uppercase',
                           whiteSpace: 'nowrap',
                        }}
                     >
                        by ZIPTUNING
                     </Box>
                  </Box>

                  <Box
                     sx={{
                        px: '8px',
                        py: '3px',
                        borderRadius: '999px',
                        bgcolor: '#00A9CE',
                        color: '#FFFFFF',
                        fontSize: '11px',
                        lineHeight: 1,
                        fontWeight: 800,
                        letterSpacing: '0.6px',
                        boxShadow: '0 2px 6px rgba(0,169,206,0.25)',
                        userSelect: 'none',
                        transform: 'translateY(-1px)',
                     }}
                  >
                     V2
                  </Box>
               </Box>
               <div style={{ flex: '1' }}></div>
               <IconButton onClick={handleDrawerClose}>
                  {theme.direction === 'ltr' ? (
                     <ChevronLeftIcon />
                  ) : (
                     <ChevronRightIcon />
                  )}
               </IconButton>
            </DrawerHeader>
            <Divider />
            <List>
               <ListItem disablePadding>
                  <ListItemButton selected={isActive('/dashboard')} onClick={() => navigate('dashboard')}>
                     <ListItemIcon>
                        <DashboardIcon />
                     </ListItemIcon>
                     <ListItemText>Dashboard</ListItemText>
                  </ListItemButton>
               </ListItem>
               <ListItem disablePadding>
                  <ListItemButton selected={isFileServiceActive} onClick={() => { setListOpen(!listopen) }}>
                     <ListItemIcon>
                        <AssignmentReturnedIcon />
                     </ListItemIcon>
                     <ListItemText>File Service</ListItemText>
                  </ListItemButton>
               </ListItem>
               <Collapse in={listopen} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                     <ListItemButton selected={isActive('/upload')} sx={{ pl: 4 }} onClick={() => { navigate('upload') }}>
                        <ListItemIcon>
                           <CloudUpload />
                        </ListItemIcon>
                        <ListItemText>Upload</ListItemText>
                     </ListItemButton>
                     <ListItemButton selected={isActive('/overview')} sx={{ pl: 4 }} onClick={() => { navigate('overview') }}>
                        <ListItemIcon>
                           <DescriptionIcon />
                        </ListItemIcon>
                        <ListItemText>
                           Overview{' '}
                           <span style={{ color: '#163A5F', fontWeight: 'bold' }}>
                              {unreadFileCount}
                           </span>
                        </ListItemText>
                     </ListItemButton>
                  </List>
               </Collapse>
               <ListItem disablePadding>
                  <ListItemButton selected={isActive('/pricelist')} onClick={() => { navigate('pricelist') }}>
                     <ListItemIcon>
                        <img src={KRIcon} alt="kr" />
                     </ListItemIcon>
                     <ListItemText>Price List</ListItemText>
                  </ListItemButton>
               </ListItem>
               <ListItem disablePadding>
                  <ListItemButton
                     selected={isActive('/toolbox')}
                     onClick={() => { navigate('toolbox') }}
                  >
                     <ListItemIcon>
                        <BuildCircleOutlinedIcon />
                     </ListItemIcon>
                     <ListItemText>Toolbox</ListItemText>
                  </ListItemButton>
               </ListItem>
               <ListItem disablePadding>
                  <ListItemButton selected={isCreditActive} onClick={() => { setCreditOpen(!creditopen) }}>
                     <ListItemIcon>
                        <CreditCardIcon />
                     </ListItemIcon>
                     <ListItemText>Credits</ListItemText>
                  </ListItemButton>
               </ListItem>
               <Collapse in={creditopen} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                     <ListItemButton selected={isActive('/overviewCredit')} sx={{ pl: 4 }} onClick={() => { navigate('overviewCredit') }}>
                        <ListItemIcon>
                           <CreditCardIcon />
                        </ListItemIcon>
                        <ListItemText>Overview</ListItemText>
                     </ListItemButton>
                     <ListItemButton selected={isActive('/buyCredit')} sx={{ pl: 4 }} onClick={() => { navigate('buyCredit') }}>
                        <ListItemIcon>
                           <ShoppingCartIcon />
                        </ListItemIcon>
                        <ListItemText>Buy File Credits</ListItemText>
                     </ListItemButton>
                  </List>
               </Collapse>
               <ListItem disablePadding>
                  <ListItemButton selected={isActive('/profile')} onClick={() => { navigate('profile') }}>
                     <ListItemIcon>
                        <PersonIcon />
                     </ListItemIcon>
                     <ListItemText>Profile</ListItemText>
                  </ListItemButton>
               </ListItem>
               <ListItem disablePadding>
                  <ListItemButton selected={isActive('/support')} onClick={checkMsg}>
                     <ListItemIcon>
                        <ErrorOutlineIcon />
                     </ListItemIcon>
                     <ListItemText>
                        Support{' '}
                        <span style={{ color: '#163A5F', fontWeight: 'bold' }}>
                           {unreadCount}
                        </span>
                     </ListItemText>
                  </ListItemButton>
               </ListItem>
            </List>
         </Drawer>
         <Main open={open}>
            <DrawerHeader />
            <div style={{ display: 'flex', height: 'calc(100vh - 64px)',overflow:'auto' }}>
               {!open ? (
                  <Drawer
                     sx={{
                        position: 'relative !important',
                        width: '80px',
                        flexShrink: 0,
                        '& .MuiDrawer-paper': {
                           position: 'relative',
                           boxSizing: 'border-box',
                        },
                     }}
                     variant="persistent"
                     anchor="left"
                     open={!open}
                  >
                     <List>
                        <ListItem disablePadding>
                           <ListItemButton
                              onClick={() => navigate('dashboard')}
                           >
                              <ListItemIcon>
                                 <DashboardIcon />
                              </ListItemIcon>
                           </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                           <ListItemButton
                              onClick={() => {
                                 setListOpen(!listopen)
                              }}
                           >
                              <ListItemIcon>
                                 <AssignmentReturnedIcon />
                              </ListItemIcon>
                           </ListItemButton>
                        </ListItem>
                        <Collapse in={listopen} timeout="auto" unmountOnExit>
                           <List component="div" disablePadding>
                              <ListItemButton
                                 sx={{ pl: 4 }}
                                 onClick={() => {
                                    navigate('upload')
                                 }}
                              >
                                 <ListItemIcon>
                                    <CloudUpload />
                                 </ListItemIcon>
                              </ListItemButton>
                           </List>
                           <List component="div" disablePadding>
                              <ListItemButton
                                 sx={{ pl: 4 }}
                                 onClick={() => {
                                    navigate('overview')
                                 }}
                              >
                                 <ListItemIcon>
                                    <DescriptionIcon />
                                    <span
                                       style={{
                                          color: '#163A5F',
                                          fontWeight: 'bold',
                                       }}
                                    >
                                       {unreadFileCount}
                                    </span>
                                 </ListItemIcon>
                              </ListItemButton>
                           </List>
                        </Collapse>
                        <ListItem
                           disablePadding
                           onClick={() => {
                              setCreditOpen(!creditopen)
                           }}
                        >
                           <ListItemButton>
                              <ListItemIcon>
                                 <CreditCardIcon />
                              </ListItemIcon>
                           </ListItemButton>
                        </ListItem>
                        <Collapse in={creditopen} timeout="auto" unmountOnExit>
                           <List component="div" disablePadding>
                              <ListItemButton
                                 sx={{ pl: 4 }}
                                 onClick={() => {
                                    navigate('overviewCredit')
                                 }}
                              >
                                 <ListItemIcon>
                                    <CreditCardIcon />
                                 </ListItemIcon>
                              </ListItemButton>
                              <ListItemButton
                                 sx={{ pl: 4 }}
                                 onClick={() => {
                                    navigate('buyCredit')
                                 }}
                              >
                                 <ListItemIcon>
                                    <ShoppingCartIcon />
                                 </ListItemIcon>
                              </ListItemButton>
                           </List>
                        </Collapse>
                        <ListItem disablePadding>
                           <ListItemButton
                              onClick={() => {
                                 navigate('profile')
                              }}
                           >
                              <ListItemIcon>
                                 <PersonIcon />
                              </ListItemIcon>
                           </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                           <ListItemButton onClick={checkMsg}>
                              <ListItemIcon>
                                 <ErrorOutlineIcon />{' '}
                                 <span
                                    style={{
                                       textAlign: 'center',
                                       color: '#163A5F',
                                       fontWeight: 'bold',
                                    }}
                                 >
                                    {unreadCount}
                                 </span>
                              </ListItemIcon>
                           </ListItemButton>
                        </ListItem>
                     </List>
                  </Drawer>
               ) : (
                  <></>
               )}
               <Outlet />
            </div>
         </Main>
      </Box>
   )
}

